/**
 * @flow
 * @relayHash 408f01118c6617fe97f2f404beeba6d5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type pdpSharedNotificationPdpSourcingModalConfigQueryVariables = {|
  itemId?: ?string,
  userId?: ?string,
|};
export type pdpSharedNotificationPdpSourcingModalConfigQueryResponse = {|
  +viewer: ?{|
    +item: ?{|
      +displayInfo: ?{|
        +ctas: ?{|
          +showRequestSourcing: ?boolean
        |}
      |}
    |}
  |}
|};
export type pdpSharedNotificationPdpSourcingModalConfigQuery = {|
  variables: pdpSharedNotificationPdpSourcingModalConfigQueryVariables,
  response: pdpSharedNotificationPdpSourcingModalConfigQueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String",
    "defaultValue": ""
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "itemId",
    "variableName": "itemId",
    "type": "String!"
  }
],
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "displayInfo",
  "storageKey": null,
  "args": [
    {
      "kind": "Variable",
      "name": "buyerId",
      "variableName": "userId",
      "type": "String"
    },
    {
      "kind": "Literal",
      "name": "page",
      "value": "pdp",
      "type": "PageDisplayEnum"
    }
  ],
  "concreteType": "ItemDisplayInfo",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "ctas",
      "storageKey": null,
      "args": null,
      "concreteType": "CTADisplay",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showRequestSourcing",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "pdpSharedNotificationPdpSourcingModalConfigQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "pdpSharedNotificationPdpSourcingModalConfigQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          },
          (v3/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "pdpSharedNotificationPdpSourcingModalConfigQuery",
    "id": "app-buyer-finding/209.0.0-2019-03-27T14:13:29.601Z/pdpSharedNotificationPdpSourcingModalConfigQuery",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5f41e8529b85e6461b6a2aa050d65c91';
module.exports = node;
